/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-has-content */

import React from 'react'

const NavigationDots = ({ active }) => (
  <div className='app__navigation'>
    {[
      'inicio',
      'acerca de',
      'portafolio',
      'habilidades',
      'testimonial',
      'contacto',
    ].map((item, index) => (
      <a
        href={`#${item}`}
        key={item + index}
        className='app__navigation-dot'
        style={active === item ? { backgroundColor: '#33b1ff' } : {}}
      />
    ))}
  </div>
)

export default NavigationDots
